
export interface SheetModel {
  suppliers: Record<any, any> | null;
  cells?: Array<RateTableModel> | null;
  key?: string | null;
}

export interface RateTableModel {
  performance: {
    from: number | null;
    to: number | null;
  };
  quality: {
    from: number | null;
    to: number | null;
  };
  rate: number;
}

export interface RateTableLocalModel {
  performance: string;
  quality: string;
  price: string;
}

export interface WorkTypeModel {
  tempId?: string | number;
  id: string | number;
  name: string;
  key: string;
  cost_center: Record<any, any> | null;
  CostAccount: Record<any, any> | null;
  work_billing_type: Record<any, any> | null;
  platform: Record<any, any> | null;
  client: Record<any, any> | null;
  rateTableCreated: boolean;
  rateTable?: Array<RateTableModel> | null;
  units: Record<any, any> | null;
  standard?: string;
  sheets?: Array<SheetModel> | null;
}

export interface WorkTypeCell {
  rateTable?: Array<RateTableModel> | null;
  cells?: any | null;
  key?: any | null;
  comment?: string | null;
}

export const defaultTable: Array<RateTableModel> = [
  { rate: 0, quality: { from: 100, to: null }, performance: { from: 100, to: null } },
  { rate: 0, quality: { from: 0, to: 100 }, performance: { from: 100, to: null } },
  { rate: 0, quality: { from: 100, to: null }, performance: { from: 0, to: 100 } },
  { rate: 0, quality: { from: 0, to: 100 }, performance: { from: 0, to: 100 } },
];
export const defaultSingleSheet: SheetModel = {
  suppliers: [],
  cells: defaultTable,
  key: null,
};

export const defaultSheet: Array<SheetModel> = [
  defaultSingleSheet,
];

export const defaultTableListLocal: Array<RateTableLocalModel> = [
  {
    performance: '100',
    quality: '100',
    price: '0',
  },
  {
    performance: '95',
    quality: '100',
    price: '0',
  },
  {
    performance: '100',
    quality: '98',
    price: '0',
  },
  {
    performance: '95',
    quality: '98',
    price: '0',
  },
];


export const defaultTableList: Array<RateTableModel> = [
  {
    performance: {
      from: 100,
      to: null,
    },
    quality: {
      from: 100,
      to: null,
    },
    rate: 0,
  },
  {
    performance: {
      from: 95,
      to: 100,
    },
    quality: {
      from: 100,
      to: null,
    },
    rate: 0,
  },
  {
    performance: {
      from: 100,
      to: null,
    },
    quality: {
      from: 98,
      to: 100,
    },
    rate: 0,
  },
  {
    performance: {
      from: 95,
      to: 100,
    },
    quality: {
      from: 98,
      to: 100,
    },
    rate: 0,
  },
];

export const defaultWorkType: WorkTypeModel = {
  id: '',
  name: '',
  key: '',
  client: null,
  platform: null,
  cost_center: null,
  CostAccount: null,
  work_billing_type: null,
  rateTableCreated: false,
  units: null,
  standard: '',
  sheets: defaultSheet,
  rateTable: defaultTable,
};
